import React from "react";
import { Container, InnerWrapper, PopUpTitle, PopUpDesc, IconContainer, } from "./index.styled";
import { CloseIcon } from "./closeIcon";
import Strings from "../../../utils/hardcoded.json";
import { Button, ButtonVariant } from "../../../components/atoms/button";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { setAuthRedirectUrl } from "../../../utils/authUrl";
const PaymentUpdateModal = ({ closePayementUpdateModal, authUrl, defaultProfileId, eMandateDialog, }) => {
    const onButtonClicked = () => {
        const lastDate = new Date();
        const publishesDate = lastDate.getTime();
        localStorage.setItem("lastPaymentUpdateMsgDisplayTime", JSON.stringify(publishesDate));
        localStorage.setItem("lastUserID", defaultProfileId);
        const authRedirect = setAuthRedirectUrl(window.location.pathname);
        window.location.replace(`${authUrl}?returnUrl=${authRedirect}`);
    };
    return (React.createElement(Container, null,
        React.createElement(InnerWrapper, null,
            React.createElement(IconContainer, { onClick: closePayementUpdateModal },
                React.createElement(CloseIcon, null)),
            Object.entries(eMandateDialog).length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(RenderMaybe, null, M.map((title) => (React.createElement(PopUpTitle, null, title)), eMandateDialog.title)),
                React.createElement(RenderMaybe, null, M.map((message) => (React.createElement(PopUpDesc, null, message)), eMandateDialog.message)))),
            React.createElement(Button, { children: Strings.OK, variant: ButtonVariant.Primary, onClickM: M.of(onButtonClicked) }))));
};
export default PaymentUpdateModal;

